import React, { useEffect, useState } from "react";
import {
  sleep,
  send,
  send300,
  receive,
  session300,
  session380,
  get_header_length,
  dec2HexString,
} from "../lib/webUSB";
import { set } from "date-fns";
import { useRecoilState } from "recoil";
import { userState } from "../states/userState";
import {
  getUSBConnectFromLocalStorage,
  setUSBConnectTolocationStorage,
  setUserToLocalStorage,
} from "../lib/localStorageManager";
export const useCardAccessor = () => {
  const [user, setUser] = useRecoilState(userState);
  const [usbDevice, setUsbDevice] = useState(null);
  const [usbConfiguration, setUsbConfiguration] = useState({});
  const [isUSBConnected, setIsUSBConnected] = useState(
    getUSBConnectFromLocalStorage()
  );
  const usbLocalStorage = getUSBConnectFromLocalStorage();
  console.log(
    "DEBUG_usbLocalStorage",
    usbLocalStorage,
    "DEBUG_usbState",
    isUSBConnected
  );
  // let usbConfiguration = {};
  let interfaceDevice = null;
  let messageText = "";
  const DeviceFilter = [
    {
      vendorId: 0x054c,
      productId: 0x06c1,
      deviceModel: 380,
    },
    {
      vendorId: 0x054c,
      productId: 0x06c3,
      deviceModel: 380,
    },
    {
      vendorId: 0x054c,
      productId: 0x0dc8,
      deviceModel: 300,
    },
    {
      vendorId: 0x054c,
      productId: 0x0dc9,
      deviceModel: 300,
    },
    // USB機器ペアリングフィルター
    // { vendorId: 1356, productId: 1729 }, // SONY PaSoRi RC-S300/S
    // { vendorId : 1356 , productId: 3529 },	// SONY PaSoRi RC-S300/P
  ];
  const deviceModelList = {
    0x06c1: 380,
    0x06c3: 380,
    0x0dc8: 300,
    0x0dc9: 300,
  };
  let deviceModel;
  let deviceEp = {
    in: 0,
    out: 0,
  };
  let seqNumber = 0;
  // let messageTitle = document.querySelector("#message-title");
  // let message = document.querySelector("#message");
  const [isPolling, setIsPolling] = useState(false);
  const [deviceOpened, setDeviceOpened] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(
    "FeliCaリーダーにカードをかざしてください"
  );
  const [isDetected, setIsDetected] = useState(false);

  const [cardId, setCardId] = useState("");
  const [cardType, setCardType] = useState("");
  let doUSBRequest = false;

  //カードリーダー起動
  const CardReaderActive = async () => {
    doUSBRequest = true;
    await usbDeviceConnect();
    // await usbDeviceOpen();
    // await usbDevicePolling();
    // await usbDeviceClose();
  };
  useEffect(() => {
    const exec = async () => {
      await usbDeviceOpen();
      await usbDevicePolling();
    };
    if (usbDevice && Object.keys(usbConfiguration).length !== 0) {
      console.log(usbDevice, usbConfiguration);
      exec();
      console.log("Call");
    }
  }, [usbDevice]);

  //カードリーダー終了
  const CardReaderStop = async () => {
    console.log(usbDevice);
    await usbDeviceClose();
  };

  //ロード時のカードリーダ起動
  useEffect(() => {
    if (isUSBConnected)
      (async () => {
        await usbDeviceClose();
        await usbDeviceConnect();
      })();
    //unmount時に呼び出し
    return () => {
      (async () => {
        await CardReaderStop();
      })();
    };
  }, []);

  const usbDeviceConnect = async () => {
    let lUsbConfiguration = {};
    console.log("connect_called!!");
    const ud = await navigator.usb.getDevices(); // ペアリング設定済みデバイスのUSBDeviceインスタンス取得
    console.log(ud);
    let lUsbDevice;
    let peared = 0;
    if (ud.length > 0) {
      for (let dev of ud) {
        const td = DeviceFilter.find(
          (fildev) =>
            dev.vendorId == fildev.vendorId && dev.productId == fildev.productId
        );
        if (td !== undefined) {
          ++peared;
          // usbDevice = dev;
          lUsbDevice = dev;
          setUsbDevice(dev);
        }
      }
    }

    if (peared != 1) {
      try {
        console.log("requestCall");
        lUsbDevice = await navigator.usb.requestDevice({
          filters: DeviceFilter,
        });
        console.log("Device selected");
        setUsbDevice(lUsbDevice);
      } catch (error) {
        console.error("No device selected", error);
        setIsUSBConnected(false);
        setUSBConnectTolocationStorage(false);
        return; // Exit the function early since no device was selected
      }
    }
    setUSBConnectTolocationStorage(true);
    setIsUSBConnected(true);
    // setUser((prevUser) => {
    //   const newUser = {
    //     ...prevUser,
    //     isUSBConnected: true,
    //   };
    //   setUserToLocalStorage(newUser);

    //   return newUser;
    // });

    lUsbConfiguration.confValue = lUsbDevice.configuration.configurationValue;
    lUsbConfiguration.interfaceNum =
      lUsbDevice.configuration.interfaces[
        lUsbConfiguration.confValue - 1
      ].interfaceNumber; // インターフェイス番号
    let ep = getEndPoint(
      lUsbDevice.configuration.interfaces[lUsbConfiguration.confValue - 1],
      "in"
    ); // 入力エンドポイントを求める
    lUsbConfiguration.endPointInNum = ep.endpointNumber; // 入力エンドポイント
    lUsbConfiguration.endPointInPacketSize = ep.packetSize; // 入力パケットサイズ
    ep = getEndPoint(
      lUsbDevice.configuration.interfaces[lUsbConfiguration.confValue - 1],
      "out"
    ); // 出力エンドポイントを求める
    lUsbConfiguration.endPointOutNum = ep.endpointNumber; // 出力エンドポイント
    lUsbConfiguration.endPointOutPacketSize = ep.packetSize; // 出力パケットサイズ
    console.log(lUsbConfiguration);
    setUsbConfiguration(lUsbConfiguration);
    deviceModel = deviceModelList[lUsbDevice.productId];
    console.log("DEBUG_deviceModel", deviceModel);
    console.log("DEBUG_usbDevice", lUsbDevice);

    return;
  };
  //	USB デバイスオープン
  const usbDeviceOpen = async () => {
    console.log("open1", usbDevice);
    // let lUsbDevice = usbDevice;
    // if (!usbDevice.opened) {
    try {
      setDeviceOpened(true);
      console.log("setDeviceOpened");
      if (!usbDevice.opened) {
        console.log("not opened", usbDevice);
        await usbDevice.open(); // USBデバイスセッション開始
      } else {
        console.log("opened", usbDevice);
        await usbDevice.close();
        await usbDevice.open();
      }
      console.log("open2", usbDevice);
      await usbDevice.selectConfiguration(usbConfiguration.confValue); // USBデバイスの構成を選択
      interfaceDevice = usbDevice.configuration.interfaces.filter(
        (v) => v.alternate.interfaceClass == 255
      )[0];
      await usbDevice.claimInterface(interfaceDevice.interfaceNumber);
      deviceEp = {
        in: interfaceDevice.alternate.endpoints.filter(
          (e) => e.direction == "in"
        )[0].endpointNumber,
        out: interfaceDevice.alternate.endpoints.filter(
          (e) => e.direction == "out"
        )[0].endpointNumber,
      };
      setIsPolling(true);
    } catch (e) {
      console.log(e);
      alert(e);
      try {
        usbDevice.close();
        setUsbDevice(null);
      } catch (e) {
        console.log(e);
      }
      setIsPolling(false);
      throw e;
      // }
    }

    return;
  };
  const usbDevicePolling = async () => {
    try {
      let result;
      do {
        // if (!usbDevice.opened) break;
        if (deviceModel == 300) {
          result = await session300(
            usbDevice,
            setIsDetected,
            deviceEp,
            seqNumber
          );
        } else {
          result = await session380(usbDevice, setIsDetected, deviceEp);
        }
        messageText = result[0];
        setCardId(result[1]);
        setCardType(result[2]);

        // console.log(messageText, cardId, cardType);
        setDisplayMessage(messageText);
        // console.log(usbDevice);
        await sleep(10);
      } while (usbDevice.opened);
    } catch (e) {
      console.log(e);
      // alert(e);
      try {
        // usbDevice.close();
        setUsbDevice(null);
      } catch (e) {
        console.log(e);
      }
      setIsPolling(false);
      // throw e;
    }
  };
  //	USB デバイスクローズ
  const usbDeviceClose = async () => {
    console.log("close");
    //message.innerHTML += "**CLOSE<br/>";
    console.log("open3", usbDevice, usbConfiguration);
    // if (usbDevice && isUSBConnected) {
    if (usbDevice) {
      await usbDevice.releaseInterface(usbConfiguration.interfaceNum); // USBデバイスの指定インターフェイスを排他アクセスを解放する
      console.log("open4", usbDevice);
      await usbDevice.close(); // USBデバイスセッション終了
      console.log("open5", usbDevice);
    }

    deviceModel = null;
    deviceEp = {
      in: 0,
      out: 0,
    };
    seqNumber = 0;
    setUsbDevice(null);
    interfaceDevice = null;
    setDeviceOpened(false);
    setUsbConfiguration({});
    setIsPolling(false);
    setIsDetected(false);
    setDisplayMessage("FeliCaリーダーにカードをかざしてください");
    return;
  };
  //USBデバイスのエンドポイントを取得
  const getEndPoint = (argInterface, argVal) => {
    let retVal = false;
    for (const val of argInterface.alternate.endpoints) {
      if (val.direction == argVal) {
        retVal = val;
      }
    }
    return retVal;
  };

  //	DataViewの8ビットバイナリを16進数で返します。
  const binArrayToHex = (argData) => {
    let retVal = "";
    let temp = [];
    for (let idx = 0; idx < argData.byteLength; idx++) {
      let bt = argData.getUint8(idx);
      let str = bt.toString(16);
      str = bt < 0x10 ? "0" + str : str;
      retVal += str.toUpperCase() + " ";
    }
    return retVal;
  };

  //	配列の要素を16進数で返します。
  const arrayToHex = (argData) => {
    let retVal = "";
    let temp = [];
    for (let val of argData) {
      let str = val.toString(16);
      str = val < 0x10 ? "0" + str : str;
      retVal += str.toUpperCase() + " ";
    }
    return retVal;
  };

  //	スリープ
  var sleep = async (msec) => {
    return new Promise((resolve) => setTimeout(resolve, msec));
  };
  return {
    isPolling,
    isDetected,
    CardReaderActive,
    CardReaderStop,
    displayMessage,
    cardId,
    cardType,
    isUSBConnected,
  };
};
